// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyACAMxzXy2BIpchklsWq1rhOr2jz1x_1pU",
  authDomain: "lwpm-aa3a9.firebaseapp.com",
  projectId: "lwpm-aa3a9",
  storageBucket: "lwpm-aa3a9.appspot.com",
  messagingSenderId: "758313963850",
  appId: "1:758313963850:web:4339be0009e17061b0b1b3",
  measurementId: "G-SSRJW5M8SZ",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export default analytics;
